/* eslint-disable */
<template>
    <v-layout row wrap >
        <v-flex lg6 sm12 xs12>
            <v-widget title="Etat professionnel ">
                <div slot="widget-content" id="q26" style="height:400px; " ref="q26"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="profession">
                <div slot="widget-content" id="q26_a" style="height:400px; " ref="q26_a"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="nature de profession">
                <div slot="widget-content" id="q27" style="height:400px; " ref="q27"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="Secteur d’activité">
                <div slot="widget-content" id="q27_a" style="height:400px; " ref="q27_a"></div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <circle-statistic
                    sub-title="Nombre moyen des heures de travail par jour "
                    caption=""
                    color="purple"
                    :value=q28            >
            </circle-statistic>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <div slot="widget-content">
                <circle-statistic
                        sub-title="Taux de femmes dans des conditions faibles de mobilité"
                        color=red darken-2
                        :value=q29
                >
                </circle-statistic>
            </div>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="Moyen de transport au travail" >

                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">A pieds </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q30.a
                                    color=pink darken-3
                            >
                                {{q30.a}}
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">En moto</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q30.b
                                    color=pink darken-3
                            >
                                {{q30.b}}
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">En camionnette </div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q30.c
                                    color=pink darken-3
                            >
                                {{q30.c}}
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Autres</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q30.d
                                    color=pink darken-3
                            >
                                {{q30.d}}
                            </v-progress-circular>
                        </div>
                    </div>
                </div>
            </v-widget>
        </v-flex>
        <v-flex lg3 sm12 xs12>
            <v-widget title="Les conditions de travail correspondent-elles avec la santé et la sécurité des femmes ?">

                <div slot="widget-content">

                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Non</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q31.a
                                    color=pink darken-3
                            >
                                {{q31.a}}
                            </v-progress-circular>
                        </div>
                    </div>
                    <div class="layout row ma-0 align-center justify-space-between">
                        <div class="text-box">
                            <div class="subheading pb-2">Oui</div>
                        </div>
                        <div class="chart">
                            <v-progress-circular
                                    :size="60"
                                    :width="5"
                                    :rotate="360"
                                    :value=q31.b
                                    color="success"
                            >
                                {{q31.b}}
                            </v-progress-circular>
                        </div>
                    </div>

                </div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="Nombre de femmes ayant respecté la période de repos biologique ">
                <div slot="widget-content" id="q32" style="height:400px; " ref="q32"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="performance des intermédiaires">
                <div slot="widget-content" id="q33" style="height:400px; " ref="q33"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget title="performance de la garde maritime">
                <div slot="widget-content" id="q34" style="height:400px; " ref="q34"></div>
            </v-widget>
        </v-flex>
        <v-flex lg6 sm12 xs12>
            <v-widget>
                <div slot="widget-content">
                    <linear-statistic
                            title="Est ce qu’il y a présence des produits marins d’autres régions ?"
                            sub-title=""
                            color=red darken-2

                            :value=q35
                    >
                    </linear-statistic>

                    <linear-statistic
                            title="Est-ce qu’il y a présence des collectrices d’autres régions ?"
                            sub-title=""
                            color=red darken-2
                            :value=q36
                    >
                    </linear-statistic>
                    <linear-statistic
                            title="Est-ce qu’il y a utilisation du tamis lors du processus de pesée et de vente des palourdes?"
                            sub-title=""
                            color=red darken-2
                            :value=q37
                    >
                    </linear-statistic>
                </div>
            </v-widget>
        </v-flex>
    </v-layout>

</template>

<script>
    import EChart from '@/components/chart/echart';
    import MiniStatistic from '@/components/widgets/statistic/MiniStatistic';
    import PostListCard from '@/components/widgets/card/PostListCard';
    import ProfileCard from '@/components/widgets/card/ProfileCard';
    import PostSingleCard from '@/components/widgets/card/PostSingleCard';
    import WeatherCard from '@/components/widgets/card/WeatherCard';
    import PlainTable from '@/components/widgets/list/PlainTable';
    import PlainTableOrder from '@/components/widgets/list/PlainTableOrder';
    import VWidget from '@/components/VWidget';
    import Material from 'vuetify/es5/util/colors';
    import VCircle from '@/components/circle/VCircle';
    import BoxChart from '@/components/widgets/chart/BoxChart';
    import ChatWindow from '@/components/chat/ChatWindow';
    import CircleStatistic from '@/components/widgets/statistic/CircleStatistic';
    import LinearStatistic from '@/components/widgets/statistic/LinearStatistic';
    var echarts = require('../../node_modules/echarts');

    /* eslint-disable */
    export default {
        name: "q1-compenent",
        components: {
            VWidget,
            MiniStatistic,
            ChatWindow,
            VCircle,
            WeatherCard,
            PostSingleCard,
            PostListCard,
            ProfileCard,
            EChart,
            BoxChart,
            CircleStatistic,
            LinearStatistic,
            PlainTable,
            PlainTableOrder
        },
        data() {
            return {
                color: Material,
                q26:'',
                q27:'',
                q35:'',
                q36:'',
                q37:'',
                q26_a:'',
                q28:'',
                q29:'0',
                q30:{
                    a:'0',
                    b:'0',
                    c:'0',
                    d:'0',
                },
                q31:{
                    a:'0',
                    b:'0',
                },

            }
        },
        computed: {
            activity() {
                return API.getActivity();
            },
            posts() {
                return API.getPost(3);
            },
            siteTrafficData() {
                return API.getMonthVisit;
            },
        },
        created(){



        },
        mounted(){
            this.  fetchData()

        },
        watch: {
            $route: function(newVal, oldVal) {
                this.fetchData()
            }
        },

        methods: {

            fetchData() {
                var labelOption1 = {

                    normal: {
                        fontSize: 16,
                        fontWeight:"bold"
                    }
                };
                const ECharts = window.echarts || undefined;
                if (ECharts === undefined) {
                    console.error('ECharts is not defined');
                }
                var labelOption3 = {

                    normal: {
                        position:"inside",

                        fontSize: 13,
                        fontWeight:"bold",
                    }
                };

                var myChart11 = ECharts.init(this.$refs.q26,'material');
                var myChart12 = ECharts.init(this.$refs.q26_a,'material');
                var myChart13 = ECharts.init(this.$refs.q27,'material');
                var myChart14 = ECharts.init(this.$refs.q27_a,'material');
                var myChart16 = ECharts.init(this.$refs.q32,'material');
                var myChart17 = ECharts.init(this.$refs.q33,'material');
                var myChart18 = ECharts.init(this.$refs.q34,'material');
                myChart11.showLoading();
                myChart12.showLoading();
                myChart13.showLoading();
                myChart14.showLoading();
                myChart16.showLoading();
                myChart17.showLoading();
                myChart18.showLoading();

                var formData = new FormData();
                if((this.$route.params.state)==='Toutes les villes'){
                    formData.append('pays','');
                }
                if((this.$route.params.state)==='Sfax'){
                    formData.append('pays','صفاقس');
                }
                if((this.$route.params.state)==='Gabès'){
                    formData.append('pays','قابس');
                }
                if((this.$route.params.state)==='Médenine'){
                    formData.append('pays','مدنين');
                }
                this.$http.post('https://acg-generations.com/acg_laravel/public/question26',formData,
                        {
                            headers: {
                                'Access-Control-Allow-Origin': '*',
                                'Access-Control-Allow-Methods': 'POST, GET, PUT, OPTIONS, DELETE',
                                'Access-Control-Allow-Headers': 'Access-Control-Allow-Methods, Access-Control-Allow-Origin, Origin, Accept, Content-Type',
                                'Content-Type': 'application/json',
                                'Accept': 'application/json'
                            }
                        }).then(response => {
                    var data = response.bodyText
                    var obj = JSON.parse(data);
                    this.q26=obj.q26;
                    this.q26_a=obj.q26_a;
                    this.q27=obj.q27;
                    this.q27_a=obj.q27_a;
                    this.q28=obj.q28;
                    this.q29=obj.q29;
                    this.q30=obj.q30;
                    this.q31=obj.q31;
                    this.q32=obj.q32;
                    this.q33=obj.q33;
                    this.q34=obj.q34;
                    this.q35=obj.q35;
                    this.q36=obj.q36;
                    this.q37=obj.q37;

                    myChart11.hideLoading();
                    myChart12.hideLoading();
                    myChart13.hideLoading();
                    myChart14.hideLoading();
                    myChart16.hideLoading();
                    myChart17.hideLoading();
                    myChart18.hideLoading();
                    var arrayq26=[
                        {value:this.q26.a,     label: labelOption1,  name:'En attente'},
                        {value:this.q26.b,      label: labelOption1, name:'Chomage'},
                        {value:this.q26.c,     label: labelOption1, name:'Travail'},
                    ]
                    var count =this.q26.count

                    myChart11.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params)
                            {var id = params.dataIndex;
                                return Math.round(arrayq26[id].value * 0.01 *count);}
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['En attente' ,'Chomage','Travail'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },
                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            label: {normal: {formatter:'{d}% ', position: 'inner'}},
                            data:arrayq26

                        }]
                    });

                    /************************************/

                    var arrayq26_a=[
                        {value:this.q26_a.a,     label: labelOption1, name:'Périodique'},
                        {value:this.q26_a.b,     label: labelOption1,name:'Fixe'},
                        {value:this.q26_a.c,     label: labelOption1, name:'Saisonnière'},

                    ]
                    var count =this.q26_a.count

                    myChart12.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params)
                            {var id = params.dataIndex;
                                return Math.round(arrayq26_a[id].value * 0.01 *count);}
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Périodique','Fixe','Saisonnière'],
                            bottom: '0',
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                            name: '',
                            type: 'pie',
                            radius: '70%',
                            label: {normal: {formatter:'{d}% ', position: 'inner'}},
                            data:arrayq26_a

                        }]
                    });
                    /*********************************************/

                    var labelOption = {
                        normal: {
                            show: true,
                            position:"inside",
                            align: "center",
                            verticalAlign: "middle",
                            formatter: '{c}%',
                            fontSize: 18,
                            rich: {
                                name: {
                                    border:0,
                                    color: "bold",

                                }
                            }
                        }
                    };

                    myChart13.setOption({
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        radius:'50%',
                        legend: {
                            bottom: '0',
                            data: ['Appartient une société', 'Travail indépendant', 'Pour un compte privé']

                        },
                        toolbox: {
                            show: true,
                            orient: 'vertical',
                            left: 'center',
                            top: 'center',
                        }, xAxis: [
                            {
                                axisTick: {show: true,
                                    alignWithLabel: true,
                                    label:true
                                },
                                data: ['nature de profession '],
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value'
                            }
                        ],
                        series: [
                            {name: "Appartient une société", type: 'bar' , label: labelOption,
                                data: [this.q27.special]},
                            {name:"Travail indépendant", type: 'bar',label: labelOption,
                                data: [this.q27.independant]},
                            {name: "Pour un compte privé", type: 'bar',  label: labelOption,
                                data:[this.q27.autre]}
                        ]

                    });
                    /*********************************************/
                    /*********************************************/
                    var arrayq27_a=[
                        {value:this.q27_a.a,     label: labelOption1,  name:'Artisanat'},
                        {value:this.q27_a.b,      label: labelOption1, name:'Agricole'},
                        {value:this.q27_a.c,     label: labelOption1, name:'Autres'},
                    ]
                    var count =this.q27_a.count
                    myChart14.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params)
                            {var id = params.dataIndex;
                                return Math.round(arrayq27_a[id].value * 0.01 *count);}
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data: ['Artisanat', 'Agricole','Autres'],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius:'70%',
                            label: {normal: {formatter:'{d}% ', position: 'inner'}},
                            data:arrayq27_a


                        }]
                    });
                    /************************************/
                    myChart16.setOption({
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        radius:'50%',
                        legend: {
                            bottom: '0',
                            data: ['Oui', 'Non']

                        },
                        toolbox: {
                            show: true,
                            orient: 'vertical',
                            left: 'right',
                            top: 'center',
                        }, xAxis: [
                            {
                                axisTick: {show: true,
                                    alignWithLabel: true,
                                    label:true
                                },
                                data: ['Respect de la période biologique'],
                            }
                        ],
                        yAxis: [
                            {
                                type: 'value'
                            }
                        ],
                        series: [
                            {name: "Oui", type: 'bar' , label: labelOption,
                                data: [this.q32.b]},
                            {name:"Non", type: 'bar',label: labelOption,
                                data: [this.q32.a]},
                        ]

                    });
                    /***********************************/
                    var arrayq33=[
                        {value:this.q33.a,     label: labelOption1,  name:'Bonne'},
                        {value:this.q33.b,      label: labelOption1, name:'Mauvaise'},
                        {value:this.q33.c,     label: labelOption1, name:'Moyenne'},
                    ];
                    var count =this.q33.count
                    myChart17.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params)
                            {var id = params.dataIndex;
                                return Math.round(arrayq33[id].value * 0.01 *count);}
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Bonne','Mauvaise','Moyenne' ],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },
                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            label: {normal: {formatter:'{d}% ', position: 'inner'}},
                            data:arrayq33
                        }]
                    });
                    /*********************************/
                    /***********************************/
                    var arrayq34=[
                        {value:this.q34.a,     label: labelOption1,  name:'Bonne'},
                        {value:this.q34.b,      label: labelOption1, name:'Mauvaise'},
                        {value:this.q34.c,     label: labelOption1, name:'Moyenne'},
                    ]
                    var count =this.q34.count

                    myChart18.setOption({
                        title: {
                            text: ''
                        },
                        tooltip: {
                            show: true,
                            formatter: function (params)
                            {var id = params.dataIndex;
                                return Math.round(arrayq34[id].value * 0.01 *count);}
                        },
                        color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],
                        yAxis: false,
                        legend: {
                            data:['Bonne','Mauvaise','Moyenne' ],
                            bottom: '0',
                            labels: {
                                fontSize: 18
                            }
                        },

                        series: [{
                            color:  [this.color.lightBlue.base, this.color.indigo.base, this.color.pink.base, this.color.green.base, this.color.cyan.base, this.color.teal.base],

                            name: '',
                            type: 'pie',
                            radius:'70%',
                            label: {normal: {formatter:'{d}% ', position: 'inner'}},
                            data:arrayq34

                        }]
                    });
                }, response => {
                    // error callback
                });
            },
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/table2FR.vue